import PermissionBundle from "@/types/roles/permissionbundle";

export const bundleShortcuts: { [Key: string]: PermissionBundle[][] } = {
    merakiDeviceAny: [
        ['@pollux.view.meraki.device.all'],
        ['@pollux.view.meraki.device.camera'],
        ['@pollux.view.meraki.device.cellular_gateway'],
        ['@pollux.view.meraki.device.router'],
        ['@pollux.view.meraki.device.sensor'],
        ['@pollux.view.meraki.device.switch'],
        ['@pollux.view.meraki.device.wireless_lan']
    ],
    merakiDeviceRebootAny: [
        ['@pollux.reboot.meraki.device.all'],
        ['@pollux.reboot.meraki.device.camera'],
        ['@pollux.reboot.meraki.device.cellular_gateway'],
        ['@pollux.reboot.meraki.device.router'],
        ['@pollux.reboot.meraki.device.sensor'],
        ['@pollux.reboot.meraki.device.switch'],
        ['@pollux.reboot.meraki.device.wireless_lan']
    ]
}
